import React, { useContext, useEffect } from 'react';

import { ContentPage, Loading } from 'components';
import { ChannelsContext } from 'lane-shared/contexts';
import { useContentForAdmin } from 'lane-shared/hooks';
import { useGetContentForServiceRequest } from 'react-hooks';
import { useTranslation } from 'react-i18next';

import styles from './CreateServiceRequest.scss';

interface CreateServiceRequestProps {
  closeSidePanel: () => void;
}

export function CreateServiceRequest({
  closeSidePanel,
}: CreateServiceRequestProps) {
  const { t } = useTranslation();
  const { primaryChannel } = useContext(ChannelsContext);

  const { fetchServiceRequestContent, contentId, error } =
    useGetContentForServiceRequest();

  useEffect(() => {
    if (primaryChannel?._id) {
      fetchServiceRequestContent(primaryChannel._id);
    }
  }, [primaryChannel?._id]);

  useEffect(() => {
    if (error) {
      window.Toast.show(t('web.admin.serviceRequest.form.content.error'));
    }
  }, [error]);

  const { content: adminContent } = useContentForAdmin({
    contentId,
  });

  if (!adminContent) return <Loading fullscreen />;

  return (
    <ContentPage
      content={adminContent}
      forAdmin
      onInteractionCreated={closeSidePanel}
      shouldNavigateToNextPage={false}
      shouldNavigateToPreviousPage={false}
      wrapperClassName={styles.createServiceRequestWrapper}
    />
  );
}
